/**
 * Which organization and project the console is looking at. The choice is remembered in
 * localStorage per browser, so a reload lands where you were; storage can be blocked, in
 * which case the choice lasts for the session.
 */

export const ORGANIZATION_KEY = "minket.organization";

/** One remembered project per organization. */
export function projectKey(organizationId: string): string {
  return `minket.project.${organizationId}`;
}

export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function store(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Private mode or storage disabled: the choice lasts for the session.
  }
}

/** The remembered organization when the user still belongs to it, else the first one. */
export function pickOrganization<T extends { organization_id: string }>(
  memberships: readonly T[],
  storedId: string | null,
): T | null {
  return memberships.find((m) => m.organization_id === storedId) ?? memberships[0] ?? null;
}

/** The remembered project when it still exists, else the first one. */
export function pickProject<T extends { id: string }>(
  projects: readonly T[],
  storedId: string | null,
): T | null {
  return projects.find((p) => p.id === storedId) ?? projects[0] ?? null;
}
